module.exports = __webpack_public_path__ + "img/big_1_34.e855c814.png";